import { UserOnboarding } from 'gql-types';

import graph from '../graph';
import io from '../io';

export const getRemoteOnBoardingState = async (): Promise<UserOnboarding> => {
    const {
        currentUser: { onboarding },
    } = await graph.get(/* GraphQL */ `
        {
            currentUser {
                onboarding {
                    hasInvitedCoworker
                    hasInvitedRecipient
                    hasCheckedCompanies
                    hasUploadedDocument
                    isSkipped
                }
            }
        }
    `);

    return onboarding;
};

export const updateRemoteOnBoardingSkip = (is_skipped = true) =>
    io.patch('/internal-api/onboarding', { is_skipped });

export const getRemoteHasSeenNewUploadingState = async (): Promise<
    Pick<UserOnboarding, 'hasSeenNewUploading'>
> => {
    const {
        currentUser: { onboarding },
    } = await graph.get(/* GraphQL */ `
        {
            currentUser {
                onboarding {
                    hasSeenNewUploading
                }
            }
        }
    `);

    return onboarding as Pick<UserOnboarding, 'hasSeenNewUploading'>;
};

export const updateRemoteHasSeenNewUploading = (
    has_seen_new_uploading = true,
) => io.patch('/internal-api/onboarding', { has_seen_new_uploading });
